import React, { useEffect } from 'react';
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import Login from "./login";
import Dashboard from "../components/admin/dashboard/index";
import Footer from '../components/reusable/admin/Footer';
import UserTypesCreate from '../components/admin/UserTypes/UserTypesCreate';
import UserTypesList from '../components/admin/UserTypes/UserTypesList';
import UserList from '../components/admin/Users/UserLIst';
import UserCreate from '../components/admin/Users/UserCreate';
import UserAttendanceCyclesCreate from '../components/admin/UserAttendanceCycles/Create';
import UserAttendanceCyclesList from '../components/admin/UserAttendanceCycles/List';
import Attendance from "../components/admin/UserAttendanceCycles/Attendance";
import AttenanceView from "../components/admin/UserAttendanceCycles/AttendanceView";
import Report from "../components/admin/Reports/index";
import Help from '../components/admin/Help/index';
import UpdateAttendanceCycle from '../components/admin/UserAttendanceCycles/UpdateAttendanceCycle';
import NotFoundPage from '../components/NotFundPage/NotFoundPage ';

const AppRoutes = () => {
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  // Role Set 
  const rawRole = localStorage.getItem('role');
  const role = rawRole ? rawRole.trim().toUpperCase() : null;
  // console.log("Normalized Role:", role);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "F1") {
        event.preventDefault();
        navigate("/admin");
      }
      else if (event.key === "F2") {
        event.preventDefault();
        navigate("/admin/reports");
      }
      else if (event.key === "F3") {
        event.preventDefault();
        navigate("/admin/users");
      }
      else if (event.key === "F4") {
        event.preventDefault();
        navigate("/admin/users/cycles");
      }
      else if (event.key === "F5") {
        event.preventDefault();
        navigate("/admin/user_types");
      }
      else if (event.key === "F6") {
        event.preventDefault();
        navigate("/admin/users/create");
      }
      else if (event.key === "F7") {
        event.preventDefault();
        navigate("/admin/users/cycles/create");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);
  return (
    <>
      <Routes>
        <Route path="/" element={token ? <Dashboard /> : <Navigate to="/login" />} />
        {/* <Route path="/" element={<Login />} /> */}
        {/* <Route path="/product_list" element={<ProductList/>} /> */}
        {/* <Route path="/product_detail/:id" element={<ProductDetail/>} /> */}
        {/* <Route path="/cart" element={<Cart/>} /> */}
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register/>} /> */}
        <Route path="/admin" element={token ? <Dashboard /> : <Navigate to="/login" />} />
        {/* <Route path="/admin/user_types" element={token ? <UserTypesList /> : <Navigate to="/login" />} /> */}
        <Route
          path="/admin/user_types"
          element={
            token && role !== 'ADMIN' ? (
              <UserTypesList />
            ) : (
              <Navigate to="/admin/help" />
            )
          }
        />

        {role !== 'VIEWER' && (
          <Route path="/admin/user_types/create" element={token ? <UserTypesCreate /> : <Navigate to="/login" />} />
        )}
        {role !== 'VIEWER' && (
          <Route path="/admin/user_types/update/:id" element={token ? <UserTypesCreate /> : <Navigate to="/login" />} />
        )}
        <Route path="/admin/users" element={token ? <UserList /> : <Navigate to="/login" />} />
        <Route path="/admin/help" element={token ? <Help /> : <Navigate to="/login" />} />
        {role !== 'VIEWER' && (
          <Route path="/admin/users/create" element={token ? <UserCreate /> : <Navigate to="/login" />} />
        )}
        {role !== 'VIEWER' && (
          <Route path="/admin/users/update/:id" element={token ? <UserCreate /> : <Navigate to="/login" />} />
        )}
        <Route path="/admin/users/cycles" element={token ? <UserAttendanceCyclesList /> : <Navigate to="/login" />} />
        {role !== 'VIEWER' && (
          <Route path="/admin/users/cycles/create" element={token ? <UserAttendanceCyclesCreate /> : <Navigate to="/login" />} />
        )}
        {role !== 'VIEWER' && (
          <Route path="/admin/users/updateattendancecycle/:id" element={token ? <UpdateAttendanceCycle /> : <Navigate to="/login" />} />
        )}
        {role !== 'VIEWER' && (
          <Route path="/admin/users/cycles/:id/attendance" element={token ? <Attendance /> : <Navigate to="/login" />} />
        )}
        <Route path="/admin/users/cycles/:id/attendance/view" element={token ? <AttenanceView /> : <Navigate to="/login" />} />
        <Route path="/admin/reports" element={token ? <Report /> : <Navigate to="/login" />} />
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
      <br />
      <Footer />
    </>
  );
};

export default AppRoutes;